import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useGetRecommendedQuery } from 'store/api/configService/gameController';
import { viewModeSelector } from 'store/slices/viewMode';

import { findPathPages } from 'utils/pages';

import { Skeleton } from '@mui/material';

import HomeComponentsLayout from 'components/Layouts/HomeComponents/HomeComponentsLayout';
import Slider from 'components/UI/Slider/Slider';

import { PAGE_PATH } from 'components/config/pages';
import { PROVIDERS } from 'config/organization';

import styles from './RecommendedGames.module.scss';

const itemsSize = 6;

const RecommendedGames = () => {
  const isWideMode = useSelector(viewModeSelector.isWide);

  const { data, isLoading } = useGetRecommendedQuery({
    provider: PROVIDERS.evoplay,
  });

  const sliderData = useMemo(
    () =>
      data
        ?.slice(0, itemsSize)
        ?.map(({ regionId, name, type, gameCode, description, images }) => ({
          regionId,
          name,
          type,
          gameCode,
          description,
          sliderSmall: images?.sliderSmall,
          sliderLarge: images?.sliderLarge,
          icon: images?.icon,
          logo: images?.logo,
        })),
    [data],
  );

  if (!isLoading && !sliderData?.length) return null;

  return (
    <HomeComponentsLayout
      title="Recommended Games"
      linkPath={findPathPages(PAGE_PATH.ALL_GAMES).replace(
        ':provider',
        PROVIDERS.evoplay,
      )}
      linkTitle="All Evoplay Games"
    >
      {!isLoading ? (
        <Slider data={sliderData} type="vertical" />
      ) : (
        <div className={styles.skeletons}>
          <Skeleton variant="rounded" height={isWideMode ? 495 : 420} />
          <div className={styles.skeletonsItems}>
            {Array(itemsSize)
              .fill(null)
              .map((_, index) => (
                <div key={index} className={styles.skeletonsItem}>
                  <Skeleton variant="rounded" height={isWideMode ? 74 : 60} />
                  <Skeleton />
                </div>
              ))}
          </div>
        </div>
      )}
    </HomeComponentsLayout>
  );
};

export default RecommendedGames;
